import {InjectionToken} from '@angular/core';

import {AOModuleEnvInterface} from '../interfaces/ao-module-env.interface';

export const AOEnvService = new InjectionToken<AOModuleEnvInterface>('AOModuleEnvInterface');
